/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SessionTerminationResponse {
  message: string;
  logout_url?: string | null;
}
